import { createFileRoute } from '@tanstack/react-router'
import { generateMetaTags } from '@/lib/seo'

// Per-user chat threads — never indexable.
export const Route = createFileRoute('/playground/$threadId')({
  head: () => ({
    meta: generateMetaTags({ noindex: true, nofollow: true }),
  }),
  component: () => null,
})
